import { Component, Injectable, OnInit } from "@angular/core";
import {
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PrivacidadePage } from "./privacidade/privacidade.page";
import { ConfigProvider } from "src/app/services/config/config";
import { UserProvider } from "src/app/services/user/user";
import { TermoUsoPage } from "../termo-uso/termo-uso.page";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { AlterarSenhaPage } from "../login/alterar-senha/alterar-senha.page";
import { environment } from "src/environments/environment";
import { Browser } from "@capacitor/browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { IonicStorageModule, Storage } from "@ionic/storage-angular";
import { Router } from "@angular/router";
import { DocumentosPage } from "../documentos/documentos.page";

declare var instituicaoConstants: {
  IS_CATHOLIC: any;
  IS_CONVENCAO: any;
  BUSCAR_INTITUICOES: number;
  TOKEN_ANONIMO: any;
  IS_PWA: boolean;
  INSTITUICAO: number;
};
@Injectable({ providedIn: "root" })
@Component({
  selector: "app-configuracao",
  templateUrl: "./configuracao.page.html",
  styleUrls: ["./configuracao.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoadingSpinnerComponent,
    DateFormatPipe,
    TranslateModule,
    IonicStorageModule,
  ],
})
export class ConfiguracaoPage implements OnInit {
  pessoa: any = { contato: {}, endereco: {}, hasMda: {} };
  idPessoa: any;
  meuCadastro = false;
  membro = false;
  editar = false;
  ddi: any;
  public isControle = false;
  idInstituicao: any;
  configs: any = {
    divulgarAniversario: {},
    divulgarContato: {},
    profissaoportal: {},
    quer_visita: {},
    receberAniversario: {},
  };
  compareWith: any;
  MyDefaultYearIdValue: string;
  loaded = false;
  keyInstituicao = "";
  hasFacebook = false;
  esconderFacebook = true;
  facebook: any = {};
  esconderCadastro = true;
  usuario: any;
  error = false;
  darkMode: any;
  idiomaList: any = [
    { id: "pt", nome: "PT - BR" },
    { id: "pt-PT", nome: "PT - PT" },
    { id: "es", nome: "ES - ES" },
    { id: "en", nome: "EN - US" },
    { id: "it", nome: "IT - IT" },
    { id: "fr", nome: "FR - FR" },
    { id: "ja", nome: "JA - JP" },
  ];
  pessoaTipo = false;
  visitante: any;

  compareWithFn(o1: any, o2: any) {
    return o1 === o2;
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public configProvider: ConfigProvider,
    public userProvider: UserProvider,
    private translate: TranslateService,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public pessoaProvider: PessoaProvider,
    public alertCtrl: AlertController,
    private storage: Storage,
    public router: Router
  ) {
    this.configProvider.getConfiguracoes().subscribe((data) => {
      this.configs = data;
    });

    this.MyDefaultYearIdValue = this.userProvider.linguagem;
    this.compareWith = this.compareWithFn;
    this.membro = this.navParams.get("membro");
    this.idPessoa = this.navParams.get("idPessoa");
    this.meuCadastro = this.navParams.get("meuCadastro");

    this.isControle = instituicaoConstants.BUSCAR_INTITUICOES == 2;

    this.userProvider.hasFacebook().subscribe((data) => {
      this.hasFacebook = data;
    });

    this.usuario = this.userProvider.loggedUser.login;

    this.userProvider.getDadosInstituicao().then((data) => {
      this.keyInstituicao = data.apiToken;
    });

    this.userProvider.getDados().then((result) => {
      this.idInstituicao = result.instituicao.id;

      this.userProvider.esconderCadastro(result.instituicao.id).subscribe((data) => {
        this.esconderCadastro = data;
      });
      if (instituicaoConstants.INSTITUICAO != 0) {
        this.userProvider.esconderCadastro(instituicaoConstants.INSTITUICAO).subscribe((data) => {
          this.esconderCadastro = data;
        });

        this.userProvider.esconderFB(instituicaoConstants.INSTITUICAO).subscribe((data) => {
          this.esconderFacebook = data;
        });
      } else {
        this.esconderCadastro = false;

        this.userProvider.esconderFBProver().subscribe((data) => {
          this.esconderFacebook = data;
        });
      }
    });

    const idPessoa = this.idPessoa ? this.idPessoa : this.userProvider.loggedUser.id;
    this.pessoaProvider.getbyId(idPessoa).subscribe({
      next: (data) => {
        this.pessoa = data;
        this.ddi = data.contato;
        this.visitante = this.userProvider.hasConfig("160");

        if (!this.visitante && this.pessoa.idPessoaTipo == 5) {
          this.pessoaTipo = true;
        }

        if ((this.visitante && this.pessoa.idPessoaTipo != 5) || !this.visitante) {
          this.pessoaTipo = true;
        }

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar os livros:", err);
        this.loaded = true;
      },
    });
  }

  ngOnInit() {
    this.getDarkMode();
  }

  async getDarkMode() {
    await this.storage.get("dark_mode").then((value) => {
      value == null ? (this.darkMode = false) : (this.darkMode = value);
    });
  }

  async changeIdioma(idioma: { detail: { value: string } }) {
    this.userProvider.setIdioma(idioma.detail.value);
  }

  setConfig(config: { status: boolean; id: any }) {
    config.status = !config.status;
    this.configProvider.setConfiguracao(config.id, config.status).subscribe(() => {});
  }

  async politicas() {
    this.userProvider.getDados().then(async (result) => {
      const modal = await this.modalCtrl.create({
        component: PrivacidadePage,
        componentProps: {
          idInstituicao: result.instituicao.id,
        },
        cssClass: "custom-modal",
      });
      await modal.present();
    });
  }

  async termos() {
    this.userProvider.getDados().then(async (result) => {
      const modal = await this.modalCtrl.create({
        component: TermoUsoPage,
        componentProps: {
          idInstituicao: result.instituicao.id,
        },
        cssClass: "custom-modal",
      });
      await modal.present();
    });
  }

  carteirinhas = async () => {
    await Browser.open({
      url:
        environment.SIS_URL +
        "frontend/carteirinha/buscar-carteirinhas-usuario?p=" +
        this.pessoa.apiKey +
        "&i=" +
        this.keyInstituicao,
    });
  };

  buscarDadosFacebook() {
    let permissions = new Array<string>();
    permissions = ["public_profile", "email"];

    // this.fb.login(permissions).then((response: FacebookLoginResponse) => {
    //   let params = new Array<string>();
    //   this.fb.api("/me?fields=name,email", params)
    //     .then(res => {

    //       let usuario: any = {};
    //       usuario.nome = res.name;
    //       usuario.email = res.email;
    //       usuario.id = res.id;
    //       usuario.foto = 'https://graph.facebook.com/' + res.id + '/picture?type=normal'
    //       usuario.token = response.authResponse.accessToken;

    //       this.facebook = usuario;

    //       this.userProvider.vincularFacebook(this.facebook).subscribe(async data => {
    //         if (!data.error) {
    //           this.hasFacebook = true;
    //         } else {
    //           let confirmAlert = await this.alertCtrl.create({
    //             header: this.translate.instant('Erro'),
    //             message: this.translate.instant(data.message),
    //             buttons: [
    //               {
    //                 text: this.translate.instant('Ok'),
    //                 role: 'cancel',
    //               }
    //             ],
    //           });
    //           confirmAlert.present();
    //         }
    //       });

    //     }, (error) => {
    //       console.log('ERROR: ', error);

    //     })
    // }, (error) => {
    //   console.log('ERROR: ', error);

    // });
  }

  async desvincularFacebook() {
    let confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Deseja realmente desvincular seu facebook?"),
      buttons: [
        {
          text: this.translate.instant("Não"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: async () => {
            let loader = this.loadingController.create({
              message: this.translate.instant("Desvinculando"),
            });

            // this.loader.present();

            this.userProvider.desvincularFacebook().subscribe((data) => {
              this.hasFacebook = false;
              // loader.dismiss();
            });
          },
        },
      ],
    });
    confirmAlert.present();
  }

  async alterarSenha() {
    const modalPage = await this.modalCtrl.create({
      component: AlterarSenhaPage,
    });
    modalPage.present();
  }

  async excluirCadastro() {
    const alert = await this.alertCtrl.create({
      subHeader: this.translate.instant("Confirme sua senha"),
      message: this.translate.instant("Após confirmar sua senha, será aberto uma solicitação de exclusão."),
      cssClass: "passwordalertcss",
      inputs: [
        {
          name: "password",
          placeholder: this.translate.instant("Senha"),
          type: "password",
        },
      ],
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.translate.instant("Confirmar"),
          handler: (data) => {
            if (data.password) {
              let password = data.password;
              let senha = {};

              if (instituicaoConstants.INSTITUICAO != 0) {
                senha = {
                  usuario: this.usuario,
                  senha: password,
                  instituicao: instituicaoConstants.INSTITUICAO,
                };
              } else {
                senha = {
                  usuario: this.usuario,
                  senha: password,
                  instituicao: 1,
                };
              }

              this.userProvider.validaSenha(senha).subscribe(async (data) => {
                if (!data.error) {
                  const alert = await this.alertCtrl.create({
                    message: this.translate.instant(data.message),
                    buttons: [
                      {
                        text: this.translate.instant("OK"),
                        handler: () => {
                          this.userProvider.logout().then(async () => {
                            if (instituicaoConstants.TOKEN_ANONIMO) {
                              this.userProvider.loggedUser = null;
                              await this.storage.set("token", instituicaoConstants.TOKEN_ANONIMO);
                              await this.userProvider.atualizarDadosPessoa().toPromise();
                              this.router.navigate(["tabs"]);
                              await this.modalCtrl.dismiss({ logout: true });
                            } else {
                              this.router.navigate(["login"]);
                              this.modalCtrl.dismiss({ logout: true });
                            }
                          });
                        },
                      },
                    ],
                  });
                  alert.present();
                } else if ((this.error = true)) {
                  const alert = await this.alertCtrl.create({
                    message: this.translate.instant(data.message),
                    buttons: [
                      {
                        text: this.translate.instant("Fechar"),
                        handler: () => {},
                      },
                    ],
                  });
                  await alert.present();
                }
              });
            }
          },
        },
      ],
    });
    await alert.present();
  }

  relatorios = async () => {
    await Browser.open({
      url: environment.PORTAL_URL + "/inicio?appKey=" + this.pessoa.apiKey,
    });
  };

  toggleTheme(e: { detail: { checked: boolean | undefined } }) {
    this.storage.set("dark_mode", e.detail.checked);
    document.body.classList.toggle("dark", e.detail.checked);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  public async documentos(idPessoa: any) {
    const data = { idPessoa: idPessoa };
    const modalPage = await this.modalCtrl.create({ component: DocumentosPage, componentProps: data });
    modalPage.present();
  }
}
